import { render, staticRenderFns } from "./v-row.vue?vue&type=template&id=72e0d773&scoped=true&"
var script = {}
import style0 from "./v-row.vue?vue&type=style&index=0&id=72e0d773&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e0d773",
  null
  
)

export default component.exports